/**
 * Returns stats HTML for site plan cards, rendering only valid values.
 * Numeric stats are rendered only when their value is greater than 0.
 *
 * @param {Array<{value: *, label: string, suffix: string, isNumeric?: boolean}>} stats
 * @returns {string} HTML string for stat items.
 */
export default function buildSiteplanStatsHtml(stats = []) {
  const hasValue = (value) => value !== null && value !== undefined && `${value}`.trim() !== '';
  const parseNumeric = (value) => {
    if (typeof value === 'number') {
      return value;
    }

    if (typeof value === 'string') {
      return Number.parseFloat(value.replace(/,/g, '').trim());
    }

    return Number.NaN;
  };

  const isPositiveNumber = (value) => {
    const parsed = parseNumeric(value);

    return Number.isFinite(parsed) && parsed > 0;
  };

  return stats
    .filter(({ value, isNumeric }) => hasValue(value) && (!isNumeric || isPositiveNumber(value)))
    .map(
      ({ value, label, suffix }) =>
        `<span class="nhs-c-siteplan-card__stat nhs-mq-siteplan-card__stat-medium" aria-label="${value} ${label}"><b aria-hidden="true">${value}</b> ${suffix}</span>`
    )
    .join('');
}